import React, { useEffect, useState } from 'react';
import '../../../CSS/Empleados.css'
import {getPermission, URIMG} from '../../../Conexiones/Conexion';
import { useNavigate } from "react-router";
import { FaArrowLeftLong } from 'react-icons/fa6';
import { deleteApi, getApi, putApi, putApiImg } from '../../../Conexiones/Models';
import { errorMessage, errorToast, successToast, warningModal, warningToast } from '../../../Utils/AlertMessage';
import { Button, CloseButton, Modal } from 'react-bootstrap';
import Loading from '../../../Utils/Loading';

function TablaProyectos() {
    const navigate = useNavigate();
    const [proyectos, setProyectos] = useState([]);
    const usuario = JSON.parse(sessionStorage.getItem('user'));
    const idUsuario = usuario[0].idUsuario;
    const uri = 'proyectos/';
    const [isLoading,setIsLoading]=useState(false);

    const regresar = () => {
        navigate('/inicio/Catalogos');
    }

    useEffect(() => {
        const getProyectos = async () => {
            setIsLoading(true);
            const permiso = await getPermission(idUsuario,4);
            if(permiso){
                const endpoint = uri;
                const res = await getApi(endpoint);
                if(res.status === 1){
                    if(res.data.length !== undefined){
                        setProyectos(res.data);
                    }else{
                        errorMessage(res.data.message);
                    }
                }else if(res.status === 210){
                    navigate('/');
                }else{
                    errorMessage(res.message);
                }
            }else{
                navigate('/inicio')
            }
            setIsLoading(false);
        }
        getProyectos();
    },[idUsuario,navigate]);

    const getProyectos = async () => {
        const endpoint = uri;
        const res = await getApi(endpoint);
        if(res.status === 1){
            if(res.data.length !== undefined){
                setProyectos(res.data);
            }else{
                errorMessage(res.data.message);
            }
        }else if(res.status === 210){
            navigate('/');
        }else{
            errorMessage(res.message);
        }
    }

    const modalEliminar = (id) => {
        warningModal("¿QUIERES ELIMINAR ESTE PROYECTO?")
        .then(async (result) => {
            if (result.isConfirmed) {
                const endpoint = uri + id;
                const res = await deleteApi(endpoint);
                if(res.status === 1){
                    if(res.data.message==="Registro eliminado"){
                        getProyectos();
                        successToast("ELIMINADO");
                    }else{
                        errorToast("¡ERROR!",res.data.message);
                    }
                }else if(res.status === 210){
                    navigate('/');
                }else{
                    errorMessage(res.message);
                }
            }
        });
    };

    const [isSaving, setSaving] = useState(false);
    const [idProyecto,setIdProyecto] = useState('')
    const [nombreProyecto,setNombreProyecto] = useState ('')
    const [imagenProyecto, setImagenProyecto] = useState(null);
    const [imgPro,setImgPro] = useState('')
    //Editar
    const [showUd, setShowUd] = useState(false);
    const handleCloseUd = () => setShowUd(false);
    const handleShowUd = () => setShowUd(true);
    const closeUpd = () =>{
        handleCloseUd()
        setIdProyecto('')
        setNombreProyecto('')
        setImagenProyecto(null)
        setImgPro('')
    }
    const showUpd = async (idp,nomp,img) => {
        const id = idp;
        const nomPro = nomp;
        const nomImg = img;
        setIdProyecto(id);
        setNombreProyecto(nomPro);
        setImgPro(nomImg);
        handleShowUd();
    }
    const update = async (e) => {
        setSaving(true)
        e.preventDefault();
        if(nombreProyecto.trim().length === 0){
            warningToast('CAMPOS VACIOS','EL CAMPO NOMBRE ESTA VACÍO');
        }else{
            if (imagenProyecto === null) {
                const endpoint = uri + idProyecto;
                const data = {nombreProyecto: nombreProyecto};
                const res = await putApi(endpoint,data);
                if(res.status === 1){
                    if(res.data.message==="¡Registro actualizado correctamente!"){
                        closeUpd();
                        getProyectos();
                        successToast("EDITADO");
                    }else{
                        errorToast("¡ERROR!",res.data.message);
                    }
                }else if(res.status === 210){
                    navigate('/');
                }else{
                    errorMessage(res.message);
                }
            } else {
                const formdata = new FormData();
                formdata.append("image", imagenProyecto);
                formdata.append("name", nombreProyecto);
                const endpoint = uri + idProyecto;
                const res = await putApiImg(endpoint,formdata);
                if(res.status === 1){
                    if(res.data.message==="¡Registro actualizado correctamente!"){
                        closeUpd();
                        getProyectos();
                        successToast("EDITADO");
                    }else{
                        errorToast("¡ERROR!",res.data.message);
                    }
                }else if(res.status === 210){
                    navigate('/');
                }else{
                    errorMessage(res.message);
                }
            }
        }
        setSaving(false)
    };
    
    return (
        <div className='empleados' >
            {
                isLoading ?
                <Loading />:
                <div>
                    <div className='contabilidades-header'>
                        <div className='fab'><FaArrowLeftLong className='arrow' onClick={regresar} title='REGRESAR'/></div>
                        <label className="text-uppercase">gestión de proyectos</label>
                    </div>
                    <div className='divbotonE' >                                                                                             
                        <div className='botonE'  style={{display:'flex', justifyContent:'end',marginBlockEnd:"20px"}}>
                            {/*<input className="form-control "  style={{width:'50%'}} type="search" placeholder="Search" aria-label="Search"/>*/}
                        </div>
                    </div>
                    {
                        proyectos.length === 0 ? (<h3 style={{marginTop:'30vh'}}>AUN NO HAY REGISTROS</h3>):(
                            <div className="tabla-cajaA" >
                                <div className="table tabla">
                                    <table className="table table-hover table-bordered ">
                                        <thead className="encabezado">
                                            <tr >
                                            <th> PROYECTO </th>
                                            <th> ACCIONES </th>
                                            </tr>
                                        </thead>
                                        <tbody >
                                            {proyectos.map(p => {
                                                return (
                                                    <tr key={p.idProyecto}>
                                                        <td valign="middle" className="text-uppercase">{p.nombreProyecto}</td>
                                                        <td>
                                                            <div>
                                                                <div className="btn iconoE" onClick={() => showUpd(p.idProyecto,p.nombreProyecto,p.imagenProyecto)} style={{margin:'5px'}}>
                                                                    <span className="bi bi-pen" title="EDITAR"></span>
                                                                </div>                                            
                                                                <div className="btn iconoE" style={{margin:'5px'}} onClick={() => modalEliminar(p.idProyecto)}>
                                                                    <span className="bi bi-trash" title="ELIMINAR"></span>
                                                                </div>                                                                    
                                                            </div>
                                                        </td>
                                                    </tr>
                                                );
                                            })}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        )
                    }

                    {/*EDITAR PROYECTO*/}
                    <Modal show={showUd} onHide={handleCloseUd} id="modal-editar-proyecto">
                        <Modal.Header className=' btncolor'>
                            <Modal.Title>EDITAR PROYECTO</Modal.Title>
                            <CloseButton  style={{backgroundColor:"white"}} onClick={closeUpd} />
                        </Modal.Header>
                        <form onSubmit={update}>
                            <div className="divO">
                                <label className="obligatorio">Obligatorio *</label>  
                            </div>
                            <Modal.Body  style={{textAlign:'left',height:'60vh', overflowY:"scroll" }}>
                                <div className="mb-3">
                                        <label htmlFor="exampleFormControlInput1" className="form-label">NOMBRE</label>
                                        <input type="text" className="form-control" value={nombreProyecto} onChange={(e) => setNombreProyecto(e.target.value)} aria-describedby="basic-addon1"/>
                                    </div>
                                    <div className="mb-3">
                                        <label htmlFor="exampleFormControlInput1" className="form-label">IMAGEN</label>
                                        <input type="file" className="form-control" id="exampleFormControlInput1" onChange={(e) => setImagenProyecto(e.target.files[0])}/>
                                    </div>
                                <div className=" mb-3">
                                    <div style={{textAlign:"center",}}>
                                        <img src={imagenProyecto === null ? URIMG + imgPro:URL.createObjectURL(imagenProyecto)} width={'50%'} alt={imgPro}/>
                                    </div>
                                </div>
                            </Modal.Body>
                            <Modal.Footer>
                                <Button type="button" className="btn btn-secondary" onClick={closeUpd}>CANCELAR</Button>                                               
                                {isSaving===true?
                                    <Button className="btn btn-primary" type="button" disabled >
                                        <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                                        Loading...
                                    </Button>:
                                    <Button type="submit" className="btn btn-light btncolor" >GUARDAR CAMBIOS</Button>                                                
                                }
                            </Modal.Footer>
                        </form>
                    </Modal>
                </div>
            }
        </div>
    );
}

export default TablaProyectos;